import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'substr'
})
export class SubstrPipe implements PipeTransform {
  transform(value: any, end = 0, init = 0): string {
    return value.substring(init, end);
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/pipes/substr.pipe.ts